<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="text-h5">
                    Min side
                </div>
            </v-col>
        </v-row>
        <v-row align="stretch">
            <v-col cols="12" md="4">
                <v-card elevation="0" color="grey lighten-3" height="100%">
                    <v-card-title>
                        Ikke levert: {{notSentInApplications.length}}
                    </v-card-title>
                    <v-card-text>
                        <v-data-table :items="notSentInApplications" :headers="headers" dense :mobile-breakpoint="0" :footer-props="footerProps">
                            <template v-slot:item.name="{item}">
                                <div @click="applicationClicked(item)" style="cursor: pointer;">
                                    {{item.name}}
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="4">
                <v-card elevation="0" color="grey lighten-3" height="100%">
                    <v-card-title>
                        Levert: {{sentInAndInProgressApplications.length}}
                    </v-card-title>
                    <v-card-text>
                        <v-data-table :items="sentInAndInProgressApplications" :headers="headers" dense :mobile-breakpoint="0" :footer-props="footerProps">

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="4">
                <v-card elevation="0" color="grey lighten-3" height="100%">
                    <v-card-title>
                        Trenger tilleggsinformasjon: {{requireInfoApplications.length}}
                    </v-card-title>
                    <v-card-text>
                        <v-data-table :items="requireInfoApplications" :headers="headers" dense :mobile-breakpoint="0" :footer-props="footerProps">
                            <template v-slot:item.name="{item}">
                                <div @click="applicationClicked(item)" style="cursor: pointer;">
                                    {{item.name}}
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <div class="clock" id="clock">
            <div class="twelve"></div>
            <div class="one"></div>
            <div class="two"></div>
            <div class="three"></div>
            <div class="four"></div>
            <div class="five"></div>
            <div class="six"></div>
            <div class="seven"></div>
            <div class="eight"></div>
            <div class="nine"></div>
            <div class="ten"></div>
            <div class="eleven"></div>
            <div class="hour">
                <div class="hr" id="hr"></div>
            </div>
            <div class="min">
                <div class="mn" id="mn"></div>
            </div>
            <div class="sec">
                <div class="sc" id="sc"></div>
            </div>
        </div>
    </v-container>
</template>

<script>
import { ApplicationStatus } from "../utilities/enums";
import { colors } from "../utilities/colors"; 
export default {
    data() {
        return {
            applications: [],
            headers:[
                { text: "Navn", value: "name" },
            ],
            footerProps: {
                'items-per-page-text': 'Rader per side:'
            },
            clockTimeout: undefined,
        }
    },
    computed: {
        company: function(){
            return this.$store.getters.company;
        },
        notSentInApplications: function() {
            return this.applications.filter(a => a.status.type === ApplicationStatus.CREATED);
        },
        sentInAndInProgressApplications: function() {
            return this.applications.filter(a => a.status.type === ApplicationStatus.ADMITTED || a.status.type === ApplicationStatus.INPROGRESS);
        },
        requireInfoApplications: function() {
            return this.applications.filter(a => a.status.type === ApplicationStatus.NEEDINFO);
        }
    },
    watch: {
        company: function() {
            this.getApplications();
        }
    },
    methods: {
        getStatus: function (application) {
            let _status = application.statuses[application.statuses.length -1];
            application.status = _status;
            return application;
        },
        getApplications: async function() {
            let _company = this.$store.getters.company;
            if(_company){
                this.applications = (await this.$store.dispatch("getApplicationsByCompany", { company: this.$store.getters.company.id})).map(a => this.getStatus(a));
            }
        },
        applicationClicked: function(application) {
            this.$router.push({name: "application", params: { id: application.id }})
        }
    },
    beforeDestroy() {
        clearInterval(this.clockTimeout);
    },
    mounted() {
        this.getApplications();

        document.getElementById("clock").style.setProperty("--color", colors.background);

        this.clockTimeout = setInterval(() => {
            let hr = document.getElementById("hr");
            let mn = document.getElementById("mn");
            let sc = document.getElementById("sc");

            let day = new Date();
            const deg = 6;
            let hh = day.getHours() * 30; // degrees, 12 hours max
            let mm = day.getMinutes() * deg;
            let ss = day.getSeconds() * deg;

            hr.style.transform = `rotateZ(${hh + (mm/12)}deg)`;
            mn.style.transform = `rotateZ(${mm}deg)`;
            sc.style.transform = `rotateZ(${ss}deg)`;
        }, 500);

        let clockElement = document.getElementById("clock")
        if(this.$vuetify.breakpoint.lgAndUp){
           
            clockElement.style.setProperty("bottom", "20px");
        }
        else{
            clockElement.style.setProperty("top", "20px");
        }
    }
};
</script>

<style lang="scss" scoped>
.clock {
    --color: #000;
    --dimension: 100px;
    width: var(--dimension);
    height: var(--dimension);
    display: flex;

    justify-content: center;
    align-items: center;

    border: 4px solid white;
    box-shadow: 0 -15px 15px rgba(255,255,255,0.05),
                inset 0 -15px 15px rgba(255,255,255,0.05),
                0 -15px 15px rgba(0,0,0,0.3),
                inset 0 -15px 15px rgba(0,0,0,0.3);

    position: absolute;
    // top: 20px;
    right: 20px;

    background: var(--color);

    border-radius: 50%;

    transition: left 2s ease-in-out;
}

.clock:before {
    content: "";
    position: absolute;
    width: 7px;
    height: 7px;
    background: white;
    border-radius: 50%;
    z-index: 10000;
}
.twelve, .one, .two, .three, .four, .five, .six, .seven, .eight, .nine, .ten, .eleven {
    position: absolute;
    width: 4px;
    height: 10px;
    background: rgb(255, 255, 255, 0.2);
}
.twelve {
    transform: translateY(calc(var(--dimension)* -0.38));
}
.one {
    transform: rotateZ(30deg) translateY(calc(var(--dimension)* -0.38));
}
.two {
    transform: rotateZ(60deg) translateY(calc(var(--dimension)* -0.38));
}
.three {
    transform: rotateZ(90deg) translateY(calc(var(--dimension)* -0.38));
}
.four {
    transform: rotateZ(120deg) translateY(calc(var(--dimension)* -0.38));
}
.five {
    transform: rotateZ(150deg) translateY(calc(var(--dimension)* -0.38));
}
.six {
    transform: rotateZ(180deg) translateY(calc(var(--dimension)* -0.38));
}
.seven {
    transform: rotateZ(210deg) translateY(calc(var(--dimension)* -0.38));
}
.eight {
    transform: rotateZ(240deg) translateY(calc(var(--dimension)* -0.38));
}
.nine {
    transform: rotateZ(270deg) translateY(calc(var(--dimension)* -0.38));
}
.ten {
    transform: rotateZ(300deg) translateY(calc(var(--dimension)* -0.38));
}
.eleven {
    transform: rotateZ(330deg) translateY(calc(var(--dimension)* -0.38));
}
.clock .hour, .clock .min, .clock .sec {
    position: absolute;
}
.clock .hour, .hr {
    width: calc(var(--dimension)* 0.5);
    height: calc(var(--dimension)* 0.5);
}
.clock .min, .mn {
    width: calc(var(--dimension)* 0.7);
    height: calc(var(--dimension)* 0.7);
}
.clock .sec, .sc {
    width: calc(var(--dimension)* 0.9);
    height: calc(var(--dimension)* 0.9);
}
.hr, .mn, .sc {
    display: flex;
    justify-content: center;
    // align-items: center;
    position: absolute;
    border-radius: 50%;
}
.hr:before {
    content: "";
    position: absolute;
    width: 4px;
    height: calc(var(--dimension)* 0.25);
    background: rgb(50, 50, 50);
    z-index: 10;
    border-radius: 3px 3px 0 0;
}
.mn:before {
    content: "";
    position: absolute;
    width: 2px;
    height: calc(var(--dimension)* 0.35);
    background: white;
    z-index: 11;
    border-radius: 3px 3px 0 0;
}
.sc:before {
    content: "";
    position: absolute;
    width: 1px;
    height: calc(var(--dimension)* 0.45);
    background: white;
    z-index: 12;
    border-radius: 3px 3px 0 0;
}
</style>